import {
    EKYCAction,
    EKYCActionType,
    IdentityVerificationActionType,
} from './identityVerificationActionType';
import { MyrAPIEndpoints } from '../../api/myr/myrAPIEndpoints.constant';
import { NotificationAction } from '../../app/common/notifications/notificationsActionType';
import { ILinkedService } from './IdentityVerificationInterface';
import { Dispatch } from 'redux';
import { ErrorResolution } from '../../app/common/errorResolution/errorResolution';
import { ErrorResolutionTypes } from '../../app/common/errorResolution/errorResolution';
import ErrorRedirectService from '../../routes/error/errorRedirect.service';
import { MyrAPIService } from '../../api/myr/myrAPI';

export default class IdentityVerificationActions {
    public static getLinkedServices(): any {
        const endpoint = MyrAPIEndpoints.EKYC;

        const request = () => ({
            payload: {},
            type: EKYCActionType.GET_LINKED_SERVICES_REQUEST,
        });

        const resolveSuccess = (
            dispatch: Dispatch<EKYCAction | NotificationAction>,
            linkedServices: ILinkedService[],
        ) => {
            dispatch({
                payload: linkedServices,
                type: EKYCActionType.GET_LINKED_SERVICES_SUCCESS,
            });
        };

        const resolveError = (
            dispatch: Dispatch<EKYCAction | NotificationAction>,
            errorResolution: ErrorResolution,
        ) => {
            dispatch({
                payload: { errorResolution },
                type: EKYCActionType.GET_LINKED_SERVICES_FAILURE,
            });
            if (errorResolution.type === ErrorResolutionTypes.RE_AUTH) {
                ErrorRedirectService.reAuth();
            }
        };

        return (dispatch: Dispatch<EKYCAction>) => {
            dispatch(request());
            return MyrAPIService.sendRequest<ILinkedService[]>(MyrAPIEndpoints.EKYC, 'GET')
                .then((json: ILinkedService[]) => {
                    return resolveSuccess(dispatch, json);
                })
                .catch((errorResolution: ErrorResolution) =>
                    resolveError(dispatch, errorResolution),
                );
        };
    }

    public static closeIdentityVerificationOverlay() {
        return {
            payload: {},
            type: IdentityVerificationActionType.CLOSE_IDENTITY_VERIFICATION_OVERLAY,
        };
    }

    public static openIdentityVerificationOverlay() {
        return {
            payload: {},
            type: IdentityVerificationActionType.OPEN_IDENTITY_VERIFICATION_OVERLAY,
        };
    }
}
